import moment from "moment/moment";

export const formatShortDate = (isoString) => {
    return isoString
        ? new Date(isoString).toLocaleDateString('en-US', {
            year: '2-digit',
            month: '2-digit',
            day: '2-digit',
        })
        : '-';
};

export const formatDate = (isoString) => {
    return moment(isoString).isValid()
        ? moment(isoString).format('MM/DD/YYYY')
        : '-';
};

export const formatToDate = (date, existingFormat, targetFormat = 'MM/DD/YYYY') => {
    return moment(date, existingFormat).isValid()
        ? moment(date, existingFormat).format(targetFormat)
        : null;
}

// Converts a picked local date/time (e.g. from a date picker, in the browser's own time
// zone) to its UTC equivalent, as an ISO-8601 string ("YYYY-MM-DDTHH:mm:ss[.SSS]Z") — the
// only format System.Text.Json's default DateTime binder reliably accepts on the backend;
// a space-separated string (no "T"/"Z") gets rejected there with a 400 before the request
// ever reaches the controller. Use this (not formatToDate) for any date+time value whose
// visibility is compared against "now" server-side (e.g. notification StartDate/EndDate) —
// formatToDate only reformats the string and keeps it in local time, which silently breaks
// that comparison across time zones.
export const toUtcDateTimeString = (date) => {
    return moment(date).isValid()
        ? moment(date).utc().toISOString()
        : null;
};


// Every value this renders (StartDate/EndDate, and CreatedOn/ModifiedOn audit columns) is
// stored as UTC — the former via toUtcDateTimeString, the latter via the backend's GETDATE().
// moment.utc(...) tells moment to read the string as UTC (it has no 'Z'/offset of its own to
// signal that); .local() then converts it to the viewer's own time zone for display. Without
// this, the raw UTC number was shown as if it were already local time — e.g. a notification
// saved as 13:28 UTC displayed literally as "01:28 PM" instead of the correct local time.
export const formatDateTime = (isoString) => {
    return moment.utc(isoString).isValid()
        ? moment.utc(isoString).local().format('MM/DD/YYYY hh:mm A')
        : '-';
};

// export const formatNotificationTime = (inputDate, nowDate = new Date()) => {
//     const date = moment.utc(inputDate);
//     const now = moment.utc(nowDate);

//     // If future date (safe handling)
//     if (date.isAfter(now)) return "few seconds ago";

//     const diffSeconds = now.diff(date, "seconds");
//     const diffMinutes = now.diff(date, "minutes");
//     const diffHours = now.diff(date, "hours"); // whole hours
//     const diffDays = now.diff(date, "days");   // whole days

//      // ✅ Less than 1 minute
//     if (diffSeconds < 60) {
//         return "few seconds ago";
//     }

//     // ✅ Less than 1 hour
//     if (diffMinutes < 60) {
//         return `${diffMinutes} minute${diffMinutes === 1 ? "" : "s"} ago`;
//     }

//     // ✅ Same day -> show hours ago
//     if (date.isSame(now, "day")) {
//         return `${diffHours} hour${diffHours === 1 ? "" : "s"} ago`;
//     }

//     // ✅ If exceeds 23 hours -> say 1 day ago
//     // (your rule #4)
//     if (diffHours > 23 && diffDays === 0) {
//         return "1 day ago";
//     }

//     // ✅ Between 1 - 9 days behind
//     if (diffDays >= 1 && diffDays <= 9) {
//         return `${diffDays} day${diffDays === 1 ? "" : "s"} ago`;
//     }

//     // ✅ 10+ days -> "Oct 20, 2024"
//     return date.format("MMM DD, YYYY");
// };
// Despite the name (kept to avoid touching every call site), this returns the current
// moment in UTC, not local wall-clock time. It's only ever used as "now" for comparing
// against a notification's StartDate/EndDate server-side, and those are stored as UTC
// (see toUtcDateTimeString) — a local-time value here would silently break that comparison
// for anyone outside UTC, exactly as it used to before this was UTC-converted.
export const getLocalDateTime = () => {
    return moment.utc().toISOString();
};

export const formatNotificationTime = (inputDate, nowDate = new Date()) => {
    if (!inputDate) return '';

    const date = moment.utc(inputDate);
    const now = moment(nowDate);

    const diffMillis = now.diff(date);
    const diffSeconds = Math.floor(diffMillis / 1000);
    const diffMinutes = Math.floor(diffSeconds / 60);
    const diffHours = Math.floor(diffMinutes / 60);
    const diffDays = Math.floor(diffHours / 24);

    if (date.isAfter(now)) return "few seconds ago";

    if (diffSeconds < 60) return `${diffSeconds} second${diffSeconds === 1 ? "" : "s"} ago`;
    if (diffMinutes < 60) return `${diffMinutes} minute${diffMinutes === 1 ? "" : "s"} ago`;
    if (diffHours < 24) return `${diffHours} hour${diffHours === 1 ? "" : "s"} ago`;
    if (diffDays === 1) return "Yesterday";
    if (diffDays <= 9) return `${diffDays} days ago`;

    return date.format("MMM DD, YYYY");
};